export default "\n  \n<router-outlet></router-outlet>\n"